import { useEffect, useState } from "react";
import { get } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import Layout from "./Shared/Layout";

const RefundandReturnPolicy = () => {
    const [staticPageData, setStaticPageData] = useState([]);
    const [error, setError] = useState('');

    const StaticPageDescriptionByStaticPageId = async () => {
        try {
            const response = await get(`${API_URL?.GetStaticPageDescriptionByStaticPageId}?pStaticPageId=4`);
            if (response.isSuccess === 1) {
                setStaticPageData(response?.data[0]);
            }
        } catch (error) {
            setError('');
        }
    };

    useEffect(() => {
        StaticPageDescriptionByStaticPageId();
    }, [])

    return (
        <Layout>
            <div className="contact-banner-sec layout_main">
                <div className="container">
                    <div className="page-header about_us_content_heading mb-3">
                        <h2>{staticPageData?.headerName || 'About Us'}</h2>
                    </div>

                    {error ? (
                        <div>Data not available</div>
                    ) : staticPageData ? (
                        <div className='about_us_content' dangerouslySetInnerHTML={{ __html: staticPageData.description || '' }} />
                    ) : (
                        <div>Loading...</div>
                    )}

                    {/* <section>
                        <div className="privacy_policy_wepper">
                            <div className="privacy_policy_inner">
                                <h2>Refund, Returns, and Exchanges Policy</h2>
                                <p>At Gailee, we strive to ensure your satisfaction with every purchase. However, if you are not completely satisfied, we are here to help. Please read our policy carefully to understand how cancellations, returns, exchanges, and refunds are handled.</p>
                            </div>

                            <div className="privacy_policy_inner">
                                <h2>Cancellation Policy</h2>
                                <p>We accept order cancellations under the following conditions:</p>
                                <p>Before Dispatch:</p>
                                <ul>
                                    <li>Orders can be canceled within 24 hours of placing the order for a full refund.</li>
                                    <li>After 24 hours but before dispatch, cancellations may be subject to a processing fee of 5% of the order value.</li>
                                </ul>

                                <p>After Dispatch:</p>
                                <ul>
                                    <li>Once the order is dispatched, cancellations will not be accepted. However, you may initiate a return or exchange after receiving the order as per our policy.</li>
                                    <li>For customized or made-to-order products, cancellations are not allowed once the production process has started.</li>
                                    <li>To cancel your order, please contact us immediately at <a className="text-primary" href="mailto:support@gailee.in">support@gailee.in</a> or WhatsApp us at 87565 62626 with your order details.</li>
                                </ul>
                            </div>

                            <div className="privacy_policy_inner">
                                <h2>Eligibility for Returns and Exchanges</h2>
                                <p>We accept returns and exchanges under the following conditions:</p>
                                <ul>
                                    <li>The product must be unused, unwashed, and in its original condition with all tags intact.</li>
                                    <li>The request for a return or exchange must be made within 7 days of receiving the order.</li>
                                    <li>Customized or tailored items, including made-to-order pieces, are non-refundable and non-exchangeable.</li>
                                    <li>Sale or discounted items are not eligible for returns but can be exchanged for another size or item of equal value.</li>
                                </ul>
                            </div>

                            <div className="privacy_policy_inner">
                                <h2>Damaged or Defective Products</h2>
                                <p>We take great care in quality checking our products before shipping. However, in the rare instance that you receive a damaged or defective product:</p>
                                <ul>
                                    <li>You must share an unboxing video clearly showing the sealed package being opened, followed by a close-up of the defect or damage.</li>
                                    <li>The unboxing video must be submitted via email or WhatsApp to our customer care team within 48 hours of receiving the package.</li>
                                    <li>Without a valid unboxing video, we will not be able to process claims for damaged or defective items.</li>
                                </ul>
                            </div>

                            <div className="privacy_policy_inner">
                                <h2>Return and Exchange Process</h2>
                                <p>To initiate a return or exchange:</p>
                                <ul>
                                    <li>Email us at <a className="text-primary" href="mailto:support@gailee.in">support@gailee.in</a> or WhatsApp us at [contact number] with your order details and the reason for the return/exchange.</li>
                                    <li>Our team will review your request and guide you on the next steps.</li>
                                    <li>Approved returns must be shipped back to us within 5 business days of receiving confirmation from our team. The shipping cost for returns will be borne by the customer unless the item is defective.</li>
                                </ul>
                            </div>

                            <div className="privacy_policy_inner">
                                <h2>Refunds</h2>
                                <p>Payment refunds are processed only for defective or damaged items (with a valid unboxing video) or if we are unable to fulfill your order. In such cases, the refund amount will be credited back into the same account (online banking, credit card, debit card) that was used to make the purchase. In case of Cash On Delivery (COD) orders, refund will be done through NEFT.</p>
                                <p>For all other eligible returns, we provide store credit or an exchange of equal value.
                                    Refunds, if applicable, will be processed within 7-10 business days after the returned product is received at our warehouse and passes the quality inspection. Please note that the timing of the actual account credit is dependent on multiple external agencies such as banks, payment gateways etc.</p>
                            </div>

                            <div className="privacy_policy_inner">
                                <h2>Additional Notes</h2>
                                <ul>
                                    <li>Products showing signs of wear, alteration, or damage caused by the customer will not be eligible for return or exchange.</li>
                                    <li>Items purchased with store credit or gift cards cannot be refunded but can be exchanged.</li>
                                    <li>We reserve the right to deny a return or exchange if the policy conditions are not met.</li>
                                    <li>We value your trust in Gailee and are committed to making your shopping experience delightful. If you have any questions, feel free to contact our customer care team at <a className="text-primary" href="mailto:support@gailee.in">support@gailee.in</a> or WhatsApp us at 87565 62626.</li>
                                </ul>
                            </div>
                        </div>
                    </section> */}
                </div>
            </div>
        </Layout>
    )
}

export default RefundandReturnPolicy;